import json from './sprite.js';

export default {
    handle: 'SP_SPS7-SpiltJuice',
    label: 'es_SPS7-SpiltJuice_234686012',
    json,
};
